






















































































































































export default function (Component) {
  Component.options.__source = "src/components/Pagination/index.vue"
}
